'use es6';

import { Map as ImmutableMap } from 'immutable';
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
export default (filters => filters.reduce((acc, filter) => acc.set(String(filter.id), ReferenceRecord({
  id: String(filter.id),
  label: filter.title,
  referencedObject: filter
})), ImmutableMap()));